import { render, staticRenderFns } from "./result.vue?vue&type=template&id=a2e38488&scoped=true&"
import script from "./result.vue?vue&type=script&lang=js&"
export * from "./result.vue?vue&type=script&lang=js&"
import style0 from "./result.vue?vue&type=style&index=0&lang=css&"
import style1 from "./result.vue?vue&type=style&index=1&id=a2e38488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e38488",
  null
  
)

export default component.exports